export { default } from './head.js'



//////////////////
// WEBPACK FOOTER
// ./node_modules/lodash-es/first.js
// module id = 395
// module chunks = 0